


















































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography, Surface, TextField } from '@/components/atoms';
import SocialMediaIcon from '@/components/icons/SocialMedia.vue';

@Component({
  components: { Typography, Surface, TextField, SocialMediaIcon }
})
export default class CampaignSectionSetting extends Vue {
  @Prop({ default: '' }) readonly value!: string;
  @Prop() readonly error!: any[];

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  mounted() {
    if (this.isMobileDevice) return;

    const campaignName = this.$refs.campaignName as any;
    campaignName.$refs.input.focus();
  }

  get tPrefix() {
    return 'sellCoins.campaign.campaignSection';
  }
}
